import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const TOO_SHORT = 'tooShort'

export function minLengthWithoutSpacesValidator(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const trimmedLength = value.replace(/\s/g, '').length;
    return trimmedLength < min
      ? { [TOO_SHORT]: { requiredLength: min, actualLength: trimmedLength } }
      : null;
  };
}
